<style>
  .sheet-content {
    padding: 0;
    border-radius: var(--tui-radius-xl);
    background-color: var(--tui-background-base);
  }
</style>

<section class="min-h-[80vh] flex flex-col sheet-content">
  @switch (viewMode) {
    @case (GroupActionsViewsTypes.Main) {
      <x-group-actions-header
        [viewObserver]="$viewObserver()"
        [title]="'group_actions.title.edit_requests' | translate"
        (viewChangedOutput)="changeViewMode($event)"
        [canGoBack]="false"
        [previousView]="previousView"
      />
      <x-main-group-actions-view
        (viewChangedOutput)="changeViewMode($event)"
      ></x-main-group-actions-view>
    }
    @case (GroupActionsViewsTypes.SelectedRequests) {
      <x-selected-requests-group-actions-view
        [previousView]="previousView"
        [viewObserver]="$viewObserver()"
        (viewChangedOutput)="changeViewMode($event)"
      ></x-selected-requests-group-actions-view>
    }
    @case (GroupActionsViewsTypes.ChangeStatus) {
      <x-group-actions-header
        [viewObserver]="$viewObserver()"
        [title]="'group_actions.title.change_status' | translate"
        (viewChangedOutput)="changeViewMode($event)"
        [canGoBack]="true"
        [previousView]="previousView"
      />
      <x-change-status-group-actions-view [viewObserver]="$viewObserver()" />
    }
    @case (GroupActionsViewsTypes.ConfirmActualDeliveryAddress) {
      <x-group-actions-header
        [viewObserver]="$viewObserver()"
        [title]="
          'group_actions.title.confirm_actual_delivery_address' | translate
        "
        (viewChangedOutput)="changeViewMode($event)"
        [canGoBack]="true"
        [previousView]="previousView"
      />
      <x-actual-delivery-address-group-actions-view
        [viewObserver]="$viewObserver()"
      />
    }
    @case (GroupActionsViewsTypes.AddDealDetails) {
      <x-group-actions-header
        [viewObserver]="$viewObserver()"
        [title]="'group_actions.title.add_deal_details' | translate"
        (viewChangedOutput)="changeViewMode($event)"
        [canGoBack]="true"
        [previousView]="previousView"
      />
      <x-request-form-deal-details
        [groupActionMode]="true"
        [viewObserver]="$viewObserver()"
      />
    }
    @case (GroupActionsViewsTypes.InternalRatings) {
      <x-group-actions-header
        [viewObserver]="$viewObserver()"
        [title]="'group_actions.title.ratings' | translate"
        (viewChangedOutput)="changeViewMode($event)"
        [canGoBack]="true"
        [previousView]="previousView"
      />
      <x-request-form-ratings
        [groupActionMode]="true"
        [viewObserver]="$viewObserver()"
      />
    }
    @case (GroupActionsViewsTypes.InstallerAssignment) {
      <x-group-actions-header
        [viewObserver]="$viewObserver()"
        [title]="'group_actions.title.installer_assignment' | translate"
        (viewChangedOutput)="changeViewMode($event)"
        [canGoBack]="true"
        [previousView]="previousView"
      />
      <x-request-installer-group-actions-view
        [viewObserver]="$viewObserver()"
        (viewChangedOutput)="changeViewMode($event)"
      />
    }
    @case (GroupActionsViewsTypes.UploadFiles) {
      <x-group-actions-header
        [viewObserver]="$viewObserver()"
        [title]="'group_actions.title.upload_files' | translate"
        (viewChangedOutput)="changeViewMode($event)"
        [canGoBack]="true"
        [previousView]="previousView"
      />
      <x-group-files-upload-group-actions-view />
    }
    @case (GroupActionsViewsTypes.ChangeReleaseDate) {
      <x-group-actions-header
        [viewObserver]="$viewObserver()"
        [title]="'group_actions.title.release_date' | translate"
        (viewChangedOutput)="changeViewMode($event)"
        [canGoBack]="true"
        [previousView]="previousView"
      />
      <x-change-release-date-group-actions-view
        [viewObserver]="$viewObserver()"
      />
    }
    @default {
      <x-main-group-actions-view
        (viewChangedOutput)="changeViewMode($event)"
      ></x-main-group-actions-view>
    }
  }
</section>
